import SelectDiscipline from "@/components/common/inputs/selectDiscipline";

export default function EventFilter(){

  return(
    <div>
      <SelectDiscipline name="asdf"  className="forminput" change={() => {}}></SelectDiscipline>
    </div>
  )
}